const utils = require('@airfi-disco/shared/utils');

const { humanizeError } = utils;

async function fetchJson(url, method, data, extraHeaders = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Fase-Shell': 'true',
      ...extraHeaders,
    },
    method,
    body: data === undefined ? undefined : JSON.stringify(data),
  });
  if (response.status === 429) {
    return Promise.reject('Too many requests');
  }
  if (response.status === 401) {
    return Promise.reject('Unauthorized');
  }
  const contentType = response.headers.get('content-type');
  if (!contentType) {
    if (!response.ok) {
      return Promise.reject(new Error(`Request failed (${response.status})`));
    }
    return Promise.resolve();
  }
  let result;
  if (contentType.indexOf('application/json') > -1) {
    result = await response.json();
  } else {
    result = await response.text();
  }
  if (!response.ok) {
    return Promise.reject(humanizeError(result));
  }
  return Promise.resolve(result);
}

export default fetchJson;
